import { FileDataResponse } from '../../../store/api/user.api';

export const detectMimeType = (base64String: string, fileName: string) => {
  let ext = fileName.substring(fileName.lastIndexOf('.') + 1);
  if (ext === undefined || ext === null || ext === '') ext = 'bin';
  ext = ext.toLowerCase();
  const signatures: Record<string, string> = {
    JVBERi0: 'application/pdf',
    R0lGODdh: 'image/gif',
    R0lGODlh: 'image/gif',
    iVBORw0KGgo: 'image/png',
    TU0AK: 'image/tiff',
    '/9j/': 'image/jpg',
    UEs: 'application/vnd.openxmlformats-officedocument.',
    PK: 'application/zip',
  };

  for (const s in signatures) {
    if (base64String.indexOf(s) === 0) {
      let x = signatures[s];
      // if an office file format
      if (ext.length > 3 && ext.substring(0, 3) === 'ppt') {
        x += 'presentationml.presentation';
      } else if (ext.length > 3 && ext.substring(0, 3) === 'xls') {
        x += 'spreadsheetml.sheet';
      } else if (ext.length > 3 && ext.substring(0, 3) === 'doc') {
        x += 'wordprocessingml.document';
      }
      // return
      return x;
    }
  }
  // if we are here we can only go off the extensions
  const extensions: Record<string, string> = {
    xls: 'application/vnd.ms-excel',
    ppt: 'application/vnd.ms-powerpoint',
    doc: 'application/msword',
    xml: 'text/xml',
    mpeg: 'audio/mpeg',
    mpg: 'audio/mpeg',
    txt: 'text/plain',
  };

  for (const e in extensions) {
    if (ext.indexOf(e) === 0) {
      const xx = extensions[e];
      return xx;
    }
  }
  // if we are here - not sure what type this is
  return 'unknown';
};

export const downloadFile = (data: FileDataResponse) => {
  const link = document.createElement('a');
  document.body.appendChild(link);
  link.setAttribute('type', 'hidden');

  const meme = detectMimeType(data.data, data?.fileName as string);
  link.href = ('data:' + meme + ';base64,' + data?.data) as string;
  link.download = data?.fileName as string;
  link.click();
  document.body.removeChild(link);
};

export const getImgUrl = (data: FileDataResponse): string => {
  const meme = detectMimeType(data.data, data.fileName);
  return ('data:' + meme + ';base64,' + data?.data) as string;
};
